export enum UserCompanyName {
  LSChicago = 'Life Science Chicago',
  LSCambridge = 'Life Science Cambridge',
  LSRemCambridge = 'Life Science REM Cambridge',
  Munich = 'ATS Munich',
  LifeScience = 'Life Science',
  APG = 'ATS Products Group',
  PA = 'Process Automation Solutions s.r.o.',
}
